import styled, {css, keyframes} from 'styled-components'
import sktDefault from 'src/assets/images/mkt04/icon_skt.png'
import sktActive from 'src/assets/images/mkt04/icon_skt_on.png'
import ktActive from 'src/assets/images/mkt04/icon_kt_on.png'
import lgActive from 'src/assets/images/mkt04/icon_lg_on.png'
import ktDefault from 'src/assets/images/mkt04/icon_kt.png'
import lgDefault from 'src/assets/images/mkt04/icon_lg.png'
import clearBtn from 'src/assets/images/mkt04/icon_clear.svg'
import {CertsStyleType} from 'src/types/type'
import {Mkt04CustomMedia, Mkt04responsiveWidth} from '.'
import 'pretendard/dist/web/static/pretendard.css'

const blink = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
`

const PhoneVerificationWrap = styled.div<Omit<CertsStyleType, 'type'> & { $isCertStage?: boolean }>`
    ${Mkt04responsiveWidth};
    display: flex;
    flex-flow: column;
    margin: ${({ $isCertStage }) => ($isCertStage ? '30px auto 10px' : '30px auto')};
    box-sizing: border-box;
    padding: 0 16px;
    gap:30px;
  
`
const SectionTitle = styled.h3<{ $invalid?: boolean }>`
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    color: ${({ $invalid }) => $invalid ? '#ff0000' : '#717580'};
    > span{
        font-weight: 700;
    }
    margin-bottom: 8px;
`
const Division = styled.section<{ $state?: 'active' | 'done' }>`
    position: relative;
    width: 100%;
    display: flex;
    flex-flow: column;
    transition: opacity .2s ease;
    ${({ $state }) => $state === 'done' && `
    opacity: 0.3;
  `}
`

const TelSelectorWrap = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13px;
    ${Mkt04CustomMedia.lessThan('midLayout')`
    gap: 13px;
 `}
    ${Mkt04CustomMedia.greaterThan('midLayout')`
     gap: 6px;
  `}
`
const TelSelect = styled.button<{
    bgActive: boolean
    actColor: string
    disabled?: boolean
}>`
    width: 100%;
    display: flex;
    height: 50px;
    box-sizing: border-box;
    padding: 13px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    border: 1px solid #CCD0D8;
    background: #fff;
    border-radius: 12px;
    & > * { pointer-events: none; }
    ${(props) =>
            props.bgActive &&
            css`
                border: 1.5px solid ${props.actColor};
                background: rgba(26, 110, 255, 0.05);
            `}
    &:disabled {
        pointer-events: none;
        cursor: not-allowed;
    }

    ${Mkt04CustomMedia.lessThan('midLayout')`
   `}

    ${Mkt04CustomMedia.greaterThan('midLayout')`
    `}
`
const Telecoms = styled.div<{ bgActive: boolean; actColor: string; oneTelStyle: boolean }>`
    width: 60px;
    height: 24px;
    flex-shrink: 0;
    background-color: transparent;
    background-size: contain;
    background-repeat: no-repeat;
    &.skt {
        background-image: url(${sktDefault});
    }

    &.kt {
        background-image: url(${ktDefault});
    }

    &.lg {
        background-image: url(${lgDefault});
    }

    ${(props) =>
            props.bgActive &&
            css`
                &.skt {
                    background-image: url(${sktActive});
                }

                &.kt {
                    background-image: url(${ktActive});
                }

                &.lg {
                    background-image: url(${lgActive});
                }
            `}
`

const PhoneInputBox = styled.div<{
    $invalid?: boolean;
    $actColor?: string;

}>`
    position: relative;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    border-radius: 12px;

    border: 1.5px solid
    ${({ $invalid, $actColor }) =>
            $invalid ? '#ff0000' : ($actColor ?? '#1A6EFF')};
    background-color: #fff;

    padding: 13px 16px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 16px;

    transition: border-color 120ms ease, background-color 120ms ease;

    &:focus-within {
        border-color: ${({ $invalid, $actColor }) =>
                $invalid ? '#ff0000' : ($actColor ?? '#1A6EFF')};
        background-color: #FAFFBD;
    }
`;

const Prefix = styled.span<{ $disabled?: boolean }>`
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    font-weight: 800;
    color: #252838;
    position: relative;
    display: flex;
    flex-flow: row nowrap;
    gap: 16px;
    &::after {
        content: '';
        display: inline-block;
        width: 1px;
        height: 20px;
        background: #CED4DF;
    }
`;
const TelInput = styled.input`
    width: 100%;
    height : 100%;
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    font-weight: 800;
    color: #1a6eff;
    background: transparent;
    &:focus {
        border: none;
        outline:none
    }
    &::placeholder {
        color: #CCD0D8
    }
`;

const  ClearBtn = styled.button<{ $visible: boolean }>`
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
    cursor: pointer;
    opacity: ${({$visible}) => ($visible ? 1 : 0)};
    pointer-events: ${({$visible}) => ($visible ? 'auto' : 'none')};
    background-image: url(${clearBtn});
    background-size: contain;
    background-repeat: no-repeat;
    background-color: transparent;

    &:active {
        background: #d1d5db;
    }
`;

const CertInput = styled.input`
    width: 100%;
    height: 100%;
    font-family: 'Pretendard', sans-serif;
    font-size: 18px;
    font-weight: 800;
    background: transparent;
    &::placeholder {
        color: #D3D5DB;
    }
    &:focus {
        border: none;
        outline:none;
    }
`

const CertInputContainer = styled.div<{
    $invalid?: boolean;
    $actColor?: string;
}>`
    position: relative;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    border-radius: 12px;

    border: 1.5px solid
    ${({ $invalid, $actColor }) =>
            $invalid ? '#ff0000' : ($actColor ?? '#1A6EFF')};
    background-color: #fff;

    padding: 13px 6px 13px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    transition: border-color 120ms ease, background-color 120ms ease;

    &:focus-within {
        border-color: ${({ $invalid, $actColor }) =>
                $invalid ? '#ff0000' : ($actColor ?? '#1A6EFF')};
        background-color: #FAFFBD;
    }
`;

const CertInputInnerBox =styled.div`
    width: 100%;
    max-width:115px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 10px;
    justify-content: end;
`
const TimerWrap = styled.span`
    font-family: 'Pretendard', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 50px;
    color: #717580;
    &.danger {
        color: #ff0000;
        animation: ${blink} 0.8s ease-in-out infinite;
    }
`
const ResendTooltip = styled.div`
    width:126px;
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  padding: 10px;
  border-radius: 12px;
  background: #313338;
  color: #fff;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
    text-align: center;
    &>span{
        font-weight: 700;
        text-decoration: underline;
    }
  &::after{
    content:'';
    position:absolute;
    top:100%;
    right: 12px;
    border: 6px solid transparent;
    border-top-color:#313338;
  }
`;

export {
    SectionTitle,
    Division,
    TelSelectorWrap,
    TelSelect,
    Telecoms,
    PhoneInputBox,
    Prefix,
    TelInput,
    CertInput,
    CertInputContainer,
    CertInputInnerBox,
    TimerWrap,
    PhoneVerificationWrap,
    ClearBtn,
    ResendTooltip,
}
